/**
 * Checks if the current window is a popup window
 * keywords: popupwindow
 */
const isPopupWindow = (): boolean =>
  window.opener && window.opener !== window && !window.menubar.visible;

export default isPopupWindow;
